import { GET } from './api'

export const Read = async () => {
    return await GET(`/ent-cotas`, true);
}
